module.exports = __webpack_public_path__ + "img/4.57d5f0f.jpg";